
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storybook",
      function () {
        return require("private-next-pages/storybook.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storybook"])
      });
    }
  